import { showAlert } from '../slices/alertSlice';
import { createAppAsyncThunk } from '../store/createAppAsyncThunk';
import { EAlert } from '../types/alert';
import { copyToClipboard } from '../utils/copyToClipboard';

export interface ICopyMessageParameters {
  messageId: string;
}

export const copyMessage = createAppAsyncThunk(
  'messages/copyMessage',
  async (
    { messageId }: ICopyMessageParameters,
    {
      dispatch,
      extra: {
        logger,
        custom: { messagesMap },
      },
    },
  ) => {
    const messageItem = messagesMap.get(messageId);

    if (!messageItem) {
      logger.error(new Error('Сообщение для копирования не найдено'), {
        domain: 'src/shared/thunks/copyMessage.ts',
        message: 'Сообщение не скопировано',
      });

      return;
    }

    const { htmlText, message } = messageItem.message.message;

    const textToCopy = htmlText || message;

    try {
      await copyToClipboard(textToCopy);
      dispatch(showAlert({ type: EAlert.Info, message: 'Сообщение скопировано' }));
    } catch (error) {
      logger.error(error, {
        domain: 'src/shared/thunks/copyMessage.ts',
        message: 'Сообщение не скопировано',
      });
    }
  },
);
